<div class="sg-input-container">
  @if (label) {
    <span class="sg-input-label">{{ label }}</span>
  }
  @if (description) {
    <p class="sg-input-description extra-small">{{ description }}</p>
  }
  <textarea
    class="textarea"
    matInput
    (input)="onInputChange($event)"
    (blur)="onBlur()"
    [attr.aria-label]="label"
    [placeholder]="placeholder"
    [rows]="rows"
    [value]="value"
    [attr.maxlength]="maxLength"
  ></textarea>
</div>
